<template>
  <div id="app">
  <div v-if="this.$router.history.current.name !='login'" class="wrapper">
    <Sidebar />
    <div class="content">
        <Navbar />
      <div  class="content-body p-4 scroll-bar smooth">
            <router-view>
            </router-view>      
      </div>
     
    </div>
  </div>
    <div v-else>
        <router-view/>        
     </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebar'
import Navbar from '@/components/navbar'

export default {
  name: 'Home',
  components: {
    Sidebar,
    Navbar,
  }
}
</script>


<style>
  .smooth {
      scroll-behavior: smooth;
  }
</style>